import { Table, useTable, Tag, Typography } from "@pankod/refine-antd";
import { Fragment } from "react";
import { MissingImageProductStatus } from "./MissingImageProductStatus";

const { Text } = Typography;

export interface IMissingProductImageTable {
  productId: number;
  masterSku: string;
  published_at: string;
  masterStatus: string;
  name: string;
  variantName: string;
  sku: string;
  quantityInVariant: number;
  quantityAvailable: number;
}

export const MissingProductImagesPanel = () => {
  const { tableProps } = useTable<IMissingProductImageTable>({
    resource: "products/missingimages",
  });

  return (
    <Fragment>
      <div style={{ display: "flex" }}>
        <div>
          <Table
            {...tableProps}
            rowKey="sku"
            style={{ minWidth: "550px", maxWidth: "800px" }}
          >
            <Table.Column<IMissingProductImageTable>
              dataIndex="published_at"
              title="Status"
              sorter
              render={(_, record) => (
                <Fragment>
                  <MissingImageProductStatus productProp={record} />
                </Fragment>
              )}
            ></Table.Column>
            <Table.Column<IMissingProductImageTable>
              dataIndex="masterStatus"
              title="Inventory Status"
              render={(status) => (
                <Tag color={status === "Active" ? "green" : "default"}>
                  {status}
                </Tag>
              )}
            ></Table.Column>
            <Table.Column<IMissingProductImageTable>
              dataIndex="name"
              title="Product Name"
              sorter
              width="220px"
              render={(name) => <Text strong>{name}</Text>}
            />
            <Table.Column<IMissingProductImageTable>
              dataIndex="variantName"
              title="Singles Type"
              render={(val) => <Tag color="blue">{val}</Tag>}
            ></Table.Column>
            <Table.Column<IMissingProductImageTable>
              dataIndex="masterSku"
              title="Master Sku"
              sorter
            ></Table.Column>
            <Table.Column<IMissingProductImageTable>
              dataIndex="quantityAvailable"
              title="Stock"
              sorter
              render={(val) => <Text type={val > 0 ? "success" : "danger"}>{val}</Text>}
            ></Table.Column>
          </Table>
        </div>
      </div>
    </Fragment>
  );
};
